import Vue from 'vue'
import PersonDocument from './person-document'
import Brochure from './brochure'
import Case from './case'
import MarketingMaterial from './marketing-material'
import Images from './images'
import Videos from './videos'
import Files from './files'
import CardStyle from './card-style'
import ListTableColumnTag from './list-table-column-tag/index.vue'
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'
import Company from './company'
import DecorationConfigCollapse from './decoration-config-collapse'
import Goods from './goods'
import ListTableColumnCarouselPicture from './list-table-column-carousel-picture'
import DecorationConfigCollapseTitle from './decoration-config-collapse-title'
import ListTableColumnMaterialType from './list-table-column-materialType'

const components = [
  PersonDocument,
  Brochure,
  Case,
  MarketingMaterial,
  Images,
  Videos,
  Files,
  CardStyle,
  ListTableColumnTag,
  MkDrawerBizTwo,
  Company,
  DecorationConfigCollapse,
  Goods,
  DecorationConfigCollapseTitle,
  ListTableColumnMaterialType
]

let componentsNameCardMap = {
  cardStyle: {
    title: '名片样式',
    defaultTitle: '名片样式',
    icon: {
      show: false,
      message: ''
    },
    name: 'cardStyle',
    component: CardStyle,
    showButton: false,
    showEdit: false
  },
  personDocument: {
    title: '个人资料',
    defaultTitle: '个人资料',
    icon: {
      show: false,
      message: ''
    },
    name: 'personDocument',
    component: PersonDocument,
    showButton: false,
    showEdit: false
  },
  brochures: {
    title: '宣传册',
    defaultTitle: '宣传册',
    icon: {
      show: false,
      message: ''
    },
    name: 'brochures',
    component: Brochure,
    showButton: true,
    showEdit: true,
    mode: 'table',
    selectAll: false,
    form: {
      tags: {
        show: true,
        data: []
      },
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    list: {
      type: 'Table', // or Image
      columns: [{
        selection: true
      }, {
        prop: 'title',
        label: '标题',
        // 自定义组件
        component: null,
        'show-overflow-tooltip': true

      }, {
        prop: 'tags',
        label: '标签',
        // 自定义组件
        component: ListTableColumnTag
      }, {
        prop: 'updateTime',
        label: '更新时间',
        // 自定义组件
        component: null,
        width: '160'

      }]
    },
    params: {
      type: 'brochure'
    },
    limit: 3
  },
  cases: {
    title: '案例',
    defaultTitle: '案例',
    icon: {
      show: false,
      message: ''
    },
    name: 'cases',
    component: Case,
    showButton: true,
    showEdit: true,
    mode: 'table',
    form: {
      tags: {
        show: true,
        data: []
      },
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    list: {
      type: 'Table', // or Image
      columns: [{
        selection: true
      }, {
        prop: 'title',
        label: '标题',
        // 自定义组件
        component: null,
        'show-overflow-tooltip': true

      }, {
        prop: 'tags',
        label: '标签',
        // 自定义组件
        component: ListTableColumnTag
      }, {
        prop: 'updateTime',
        label: '更新时间',
        // 自定义组件
        component: null,
        width: '160'

      }]
    },
    params: {
      type: 'case'
    },
    limit: 6
  },
  materials: {
    title: '营销资料',
    defaultTitle: '营销资料',
    icon: {
      show: true,
      message: '名片不支持添加任意链接转载文章'
    },
    name: 'materials',
    component: MarketingMaterial,
    showButton: true,
    showEdit: true,
    mode: 'table',
    form: {
      radio: {
        label: '资料类型',
        show: true,
        data: [{
          label: '文章',
          name: 'article'
        }, {
          label: 'H5',
          name: 'h5'
        }, {
          label: '表单',
          name: 'form'
        }]
      },
      tags: {
        show: true,
        data: []
      },
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    list: {
      type: 'Table', // or Image
      columns: [{
        selection: true
      }, {
        prop: 'title',
        label: '标题',
        // 自定义组件
        component: null,
        'show-overflow-tooltip': true

      }, {
        prop: 'tags',
        label: '标签',
        // 自定义组件
        component: ListTableColumnTag
      }, {
        prop: 'updateTime',
        label: '更新时间',
        // 自定义组件
        component: null,
        width: '160'

      }]
    },
    params: {
      type: 'article'
    },
    // 数量限制
    limit: 6
  },
  videos: {
    title: '视频',
    defaultTitle: '视频',
    icon: {
      show: false,
      message: ''
    },
    name: 'videos',
    component: Videos,
    showButton: true,
    showEdit: true,
    mode: 'table',
    list: {
      type: 'Table', // or Image
      columns: [{
        selection: true
      }, {
        prop: 'title',
        label: '标题',
        // 自定义组件
        component: null,
        'show-overflow-tooltip': true

      }, {
        prop: 'tags',
        label: '标签',
        // 自定义组件
        component: ListTableColumnTag
      }, {
        prop: 'updateTime',
        label: '更新时间',
        // 自定义组件
        component: null,
        width: '160'

      }]
    },
    form: {
      tags: {
        show: true,
        data: []
      },
      radio: {
        label: '视频类型',
        show: true,
        data: [{
          label: '普通视频',
          name: 'ordinaryVideo'
        }, {
          label: '营销视频',
          name: 'video-markting'
        }]
      },
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    params: {
      type: 'ordinaryVideo'
    },
    limit: 3
  },
  images: {
    title: '图片',
    defaultTitle: '图片',
    icon: {
      show: false,
      message: ''
    },
    name: 'images',
    component: Images,
    showButton: true,
    showEdit: true,
    mode: 'image',
    form: {
      radio: {
        label: '图片类型',
        show: true,
        data: [{
          label: '图片',
          name: 'picture'
        }, {
          label: '海报',
          name: 'poster'
        }]
      },
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    params: {
      type: 'picture'
    },
    // 数量限制
    limit: 9
  },
  documents: {
    title: '文件',
    defaultTitle: '文件',
    icon: {
      show: true,
      message: '小程序暂不支持TXT格式'
    },
    name: 'documents',
    component: Files,
    showButton: true,
    showEdit: true,
    mode: 'table',
    form: {
      select: {
        placeholder: '文件类型',
        data: [{
          label: '全部',
          value: 0
        }, {
          label: '文档',
          value: 1
        }, {
          label: '表格',
          value: 2
        }, {
          label: 'PDF',
          value: 3
        }, {
          label: '幻灯片',
          value: 5
        }, {
          label: '图片',
          value: 6
        }, {
          label: '音频',
          value: 7
        }, {
          label: '视频',
          value: 8
        }]
      },
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    list: {
      type: 'Table', // or Image
      columns: [{
        selection: true
      }, {
        prop: 'materialType',
        label: '类型',
        // 自定义组件
        component: ListTableColumnMaterialType,
        width: '150'
      }, {
        prop: 'title',
        label: '标题',
        // 自定义组件
        component: null,
        'show-overflow-tooltip': true

      }, {
        prop: 'updateTime',
        label: '更新时间',
        // 自定义组件
        component: null,
        width: '160'

      }]
    },
    params: {
      type: 'file'
    },
    limit: 9
  }
}

let componentsGoodsSettingMap = {
  goods: {
    title: '商品设置',
    defaultTitle: '商品设置',
    name: 'goods',
    icon: {
      show: false,
      message: ''
    },
    mode: 'table',
    component: Goods,
    showButton: true,
    showEdit: false,
    form: {
      input: {
        show: true,
        placeholder: '请输入商品名称'
      }
    },
    list: {
      type: 'Table', // or Image
      columns: [{
        selection: true
      }, {
        prop: 'carouselPicture',
        label: '商品主图',
        // 自定义组件
        component: ListTableColumnCarouselPicture
      }, {
        prop: 'name',
        label: '商品名称',
        showOverflowTooltip: true,
        // 自定义组件
        component: null
      }, {
        prop: 'desc',
        label: '描述',
        showOverflowTooltip: true,
        // 自定义组件
        component: null
      }]
    },
    limit: 9,
    params: {
      type: 'good'
    }
  }
}
components.forEach((item) => {
  Vue.component(item.name, item)
})

export default {
  componentsNameCardMap,
  componentsGoodsSettingMap
}
